import { Container, Stack } from "@mui/material";
import { PollService, UserPollDto } from "../../../api/psc";
import {
    EmptyListMessage,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import PollListItem from "../components/PollListItem";

export default function ListPolls() {
    const manager = useDynamicList<UserPollDto>((offset) => {
        return PollService.getPolls("1");
    });

    if (manager.requestInProgress && manager.results.length === 0) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="sm">
            <PageHeader title="نظرسنجی ها" />

            {manager.empty && (
                <EmptyListMessage message="نظرسنجی فعالی در این لحظه یافت نشد" />
            )}

            <Stack spacing={1.5}>
                {manager.results.map((p) => {
                    return <PollListItem key={p.id} item={p} />;
                })}
            </Stack>
        </Container>
    );
}
